import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const ME_STORAGE_KEY = 'jusic_me_identity'

function readLocalPreference(key, fallback) {
    try { return window.localStorage.getItem(key) || fallback; } catch (e) { return fallback; }
}

function normalizeIdentity(value) {
    if (value == null) return ''
    const text = String(value).trim()
    if (!text || text === 'null' || text === 'undefined') return ''
    return text
}

function pushUnique(list, value) {
    const text = normalizeIdentity(value)
    if (!text) return
    if (list.indexOf(text) === -1) {
        list.push(text)
    }
}

function loadMeIdentity() {
    const empty = { sessionIds: [], nickNames: [], pickedIds: [] }
    try {
        const raw = window.sessionStorage.getItem(ME_STORAGE_KEY)
        if (!raw) return empty
        const obj = JSON.parse(raw)
        return {
            sessionIds: Array.isArray(obj.sessionIds) ? obj.sessionIds.filter(normalizeIdentity) : [],
            nickNames: Array.isArray(obj.nickNames) ? obj.nickNames.filter(normalizeIdentity) : [],
            pickedIds: Array.isArray(obj.pickedIds) ? obj.pickedIds.filter(normalizeIdentity) : []
        }
    } catch (e) {
        return empty
    }
}

function persistMeIdentity(me) {
    try {
        window.sessionStorage.setItem(ME_STORAGE_KEY, JSON.stringify(me))
    } catch (e) { /* ignore */ }
}

export default new Vuex.Store({
    state: {
        socket: {
            socketClient: {},
            stompClient: {},
            stompHeaders: {},
            online: 0,
            isConnected: false,
            identityReady: false,
            identityId: '',
            userName: readLocalPreference('USER_NAME', null),
            isRoot: false,
            isAdmin: false,
			good:false
        },
        player: {
            pick: [],
            music: {},
            lyrics: [],
            lyric: '',
            volume: Number(readLocalPreference('VOLUME', 10)),
            progress: 0,
            time: '00:00 / 00:00',
			music2:{}
        },
        chat: {
            data: [],
            message: ''
        },
        search: {
            keyword: '',
            count: 0,
            data: [],
            picture: {
                keyword: '',
                count: 0,
                data: [],
            }
        },
        // P1 点歌历史（最新在前）
        history: {
            list: []
        },
        // 最近一次从历史/搜索发起的点歌提示文案（用于 NOTICE toast）
        pendingPickHint: null,
        pickRequests: [],
        skipVote: null,
        // 「只看自己」身份：sessionId / 服务端昵称 / 本会话点过的 songId
        me: loadMeIdentity()
    },
    getters: {
        getSocket: state => {
            return state.socket;
        },
        getPlayer: state => {
            return state.player;
        },
        getChat: state => {
            return state.chat;
        },
        getSocketClient: state => {
            return state.socket.socketClient;
        },
        getStompClient: state => {
            return state.socket.stompClient;
        },
        getStompHeaders: state => {
            return state.socket.stompHeaders;
        },
        getSocketOnline: state => {
            return Number(state.socket.online);
        },
        getIsConnected: state => {
            return Boolean(state.socket.isConnected);
        },
        getIdentityReady: state => state.socket.identityReady,
        getIdentityId: state => state.socket.identityId,
        getPickRequests: state => state.pickRequests,
        getSkipVote: state => state.skipVote,
        getSocketUserName: state => {
            return String(state.socket.userName);
        },
        isSocketRoot: state => {
            return Boolean(state.socket.isRoot)
        },
        isSocketAdmin: state => {
            return Boolean(state.socket.isAdmin)
        },
		isSocketGood:state =>{
			return Boolean(state.socket.good)
		},
        getPlayerMusic: state => {
            return state.player.music;
        },
		getMusic2: state => {
            return state.player.music2;
        },
        getPlayerLyrics: state => {
            return state.player.lyrics;
        },
        getPlayerLyric: state => {
            return state.player.lyric;
        },
        getPlayerPick: state => {
            return state.player.pick;
        },
        getPlayerVolume: state => {
            return Number(state.player.volume);
        },
        getPlayerProgress: state => {
            return Number(state.player.progress);
        },
        getPlayerTime: state => {
            return String(state.player.time);
        },
        getChatData: state => {
            return state.chat.data;
        },
        getChatMessage: state => {
            return state.chat.message;
        },
        getSearchKeyword: state => {
            return state.search.keyword
        },
        getSearchData: state => {
            return state.search.data
        },
        getSearchCount: state => {
            return state.search.count
        },
        getSearchPictureKeyword: state => {
            return state.search.picture.keyword
        },
        getSearchPictureData: state => {
            return state.search.picture.data
        },
        getSearchPictureCount: state => {
            return state.search.picture.count
        },
        getHistoryList: state => {
            return state.history.list
        },
        getPendingPickHint: state => state.pendingPickHint,
        getMeSessionIds: state => state.me.sessionIds,
        getMeNickNames: state => state.me.nickNames,
        getMePickedIds: state => state.me.pickedIds
    },
    mutations: {
        setSocketClient: (state, value) => {
            state.socket.socketClient = value
        },
        setStompClient: (state, value) => {
            state.socket.stompClient = value;
        },
        setStompHeaders: (state, value) => {
            state.socket.stompHeaders = value;
        },
        setSocketOnline: (state, value) => {
            state.socket.online = value;
        },
        setSocketIsConnected: (state, value) => {
            state.socket.isConnected = value;
        },
        setIdentityReady: (state, value) => { state.socket.identityReady = Boolean(value); },
        setSkipVote: (state, value) => { state.skipVote = value || null; },
        setRoomIdentity: (state, value) => {
            state.socket.identityId = value.identityId;
            state.socket.identityReady = true;
        },
        beginPickRequest: (state, value) => {
            state.pickRequests.push(value);
            if (state.pickRequests.length > 200) {
                const index = state.pickRequests.findIndex(item => item.status !== 'processing' && (!value.batchId || item.batchId !== value.batchId));
                if (index >= 0) state.pickRequests.splice(index, 1);
            }
        },
        updatePickRequest: (state, value) => {
            const index = state.pickRequests.findIndex(item => item.requestId === value.requestId);
            if (index < 0) return;
            Vue.set(state.pickRequests, index, {...state.pickRequests[index], ...value});
        },
        clearCompletedPickRequests: state => {
            state.pickRequests = state.pickRequests.filter(item => item.status === 'processing' || item.status === 'unconfirmed');
        },
        setSocketUserName: (state, value) => {
            state.socket.userName = value;
            try { window.localStorage.setItem('USER_NAME', value); } catch (e) { /* The current connection still keeps its nickname. */ }
        },
        setSocketRoot: (state, value) => {
            state.socket.isRoot = Boolean(value)
        },
        setSocketAdmin: (state, value) => {
            state.socket.isAdmin = Boolean(value)
        },
		setSocketGood: (state, value) => {
            state.socket.good = Boolean(value)
        },
        setPlayerMusic: (state, value) => {
            state.player.music = value;
        },
		setMusic2: (state, value) => {
            state.player.music2 = value;
        },
        setPlayerLyrics: (state, value) => {
            state.player.lyrics = value;
        },
        setPlayerLyric: (state, value) => {
            state.player.lyric = value;
        },
        setPlayerPick: (state, value) => {
            state.player.pick = value;
        },
        setPlayerVolume: (state, value) => {
            state.player.volume = value;
            try { window.localStorage.setItem('VOLUME', value); } catch (e) { /* The live volume still changes. */ }
        },
        setPlayerProgress: (state, value) => {
            state.player.progress = value;
        },
        setPlayerTime: (state, value) => {
            state.player.time = value;
        },
        pushChatData: (state, value) => {
            state.chat.data.push(value);
        },
        clearChatData: (state) => {
            state.chat.data = [];
        },
        setChatMessage: (state, value) => {
            state.chat.message = value;
        },
        setSearchKeyword: (state, value) => {
            state.search.keyword = value
        },
        setSearchData: (state, value) => {
            state.search.data = value
        },
        setSearchCount: (state, value) => {
            state.search.count = value
        },
        setSearchPictureKeyword: (state, value) => {
            state.search.picture.keyword = value
        },
        setSearchPictureData: (state, value) => {
            state.search.picture.data = value
        },
        setSearchPictureCount: (state, value) => {
            state.search.picture.count = value
        },
        setHistoryList: (state, value) => {
            state.history.list = Array.isArray(value) ? value : []
        },
        setPendingPickHint: (state, value) => {
            state.pendingPickHint = value
        },
        rememberMeSessionId: (state, value) => {
            pushUnique(state.me.sessionIds, value)
            persistMeIdentity(state.me)
        },
        rememberMeNickName: (state, value) => {
            pushUnique(state.me.nickNames, value)
            persistMeIdentity(state.me)
        },
        rememberMePickedId: (state, value) => {
            pushUnique(state.me.pickedIds, value)
            persistMeIdentity(state.me)
        }
    },
    actions: {},
    modules: {}
});
